export const CustomLabel = props => {
  return (
    <g>
      <rect
        x={props.viewBox.x - 55}
        y={props.viewBox.y}
        fill="#2158CF"
        width={110}
        height={28}
        rx="15"
      />
      <text
        x={props.viewBox.x}
        y={props.viewBox.y - 4}
        dominant-baseline="middle"
        text-anchor="middle"
        fill="#FFFFFF"
        dy={20}
        dx={0}
        fontSize={12}
      >
        Directful launch
      </text>
    </g>
  )
}
